import React from "react";
import { StaticImage } from "gatsby-plugin-image";

const Img3 = () => {
  return (
    <StaticImage
      placeholder="blurred"
      src="../../../images/img_coll_3.png"
      alt="collar inteligente Kolyy"
    />
  );
};

export default Img3;
